import { useCallback, useMemo } from 'react';
import { useGetSuppliersQuery } from '@/lib/api/lookupsApi';
import { useModuleLookups } from '@/hooks';
import { buildLookupOptions } from '@/config/formOptions';
import { buildRawMaterialTypeOptions } from '@/config/rawMaterialTypes.constants';
import { resolveEquivalentUnit } from '@/lib/mappers';
import { EMPTY_LIST } from '@/lib/utils';

// Everything <ContractForm> needs from the server — see slices/contracts/CLAUDE.md.
export const useContractFormOptions = () => {
  // No stock check: the contract form picks its material after the facility.
  const { sites, materials, facilityOptions, materialsLoading } = useModuleLookups({
    stockCheck: false,
  });
  const { data: suppliers = EMPTY_LIST, isLoading: suppliersLoading } = useGetSuppliersQuery();

  const options = useMemo(
    () => ({
      facilities: facilityOptions,
      suppliers: buildLookupOptions(suppliers),
      rawMaterialTypes: buildRawMaterialTypeOptions(),
    }),
    [facilityOptions, suppliers],
  );

  // Resolved at submit time, where the material is only known by id.
  const getEquivalentUnit = useCallback(
    (values) => {
      const material = materials.find((item) => item.id === values.materialId) ?? null;
      return resolveEquivalentUnit({ unit: values.unit, material });
    },
    [materials],
  );

  return {
    options,
    sites,
    materials,
    getEquivalentUnit,
    isLoading: materialsLoading || suppliersLoading,
  };
};
